import { MAX_ITERATIONS_IN_CHARTS } from '@/constants/ANALYTICS.ts'
import { STORY_STATUSES } from '@/constants/STORY_STATUSES.ts'
import { STORY_TYPES } from '@/constants/STORY_TYPES.ts'
import { calculateMedianMillis } from '@/utils/math.ts'
import { useMemo } from 'react'

export const useStackedBarChartData = (iterations: IterationSummary[] = []) => {
  const storiesAcceptedData = useMemo(() => {
    if (!iterations || iterations.length === 0) return []

    return iterations.slice(-MAX_ITERATIONS_IN_CHARTS).map((iteration) => {
      const acceptedStories = iteration.stories.filter(
        (s) => s.status === STORY_STATUSES.ACCEPTED && s.storyType !== STORY_TYPES.RELEASE,
      )

      return {
        iterationDate: new Date(iteration.start),
        iterationNumber: iteration.number,
        feature: acceptedStories.filter((s) => s.storyType === STORY_TYPES.FEATURE).length,
        design: acceptedStories.filter((s) => s.storyType === STORY_TYPES.DESIGN).length,
        chore: acceptedStories.filter((s) => s.storyType === STORY_TYPES.CHORE).length,
        bug: acceptedStories.filter((s) => s.storyType === STORY_TYPES.BUG).length,
      }
    })
  }, [iterations])

  const storyCycleTimeData = useMemo(() => {
    if (!iterations || iterations.length === 0) return []

    return iterations.slice(-MAX_ITERATIONS_IN_CHARTS).map((iteration) => {
      const acceptedStories = iteration.stories.filter((s) => s.status === STORY_STATUSES.ACCEPTED)

      const getMedianForType = (storyType: string) => {
        return calculateMedianMillis(
          acceptedStories.filter((s) => s.storyType === storyType).map((s) => s.cycleTimeDetails.totalCycleTime),
        )
      }

      return {
        iterationDate: new Date(iteration.start),
        iterationNumber: iteration.number,
        feature: getMedianForType(STORY_TYPES.FEATURE),
        design: getMedianForType(STORY_TYPES.DESIGN),
        chore: getMedianForType(STORY_TYPES.CHORE),
        bug: getMedianForType(STORY_TYPES.BUG),
      }
    })
  }, [iterations])

  return {
    storiesAcceptedData,
    storyCycleTimeData,
  }
}
